<!--
@Time : 2020/11/30 4:45 上午
@Author : yekong
@File : zhengti.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="zt">
      <div class="ztitem" :class="{active:active==0}" @click="getactive(0)">

        <p>整体</p>
        <div class="line3"></div>
      </div>
      <div class="ztitem" :class="{active:active==1}" @click="getactive(1)">
        <p>明细</p>
        <div class="line3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhengti",
  data: function () {
    return {
      active: 0,
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
      this.$emit('getactive', e)
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.zt {
  width: 340px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .ztitem {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 0.6;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;

    p {
      position: relative;
      z-index: 1;
    }

    .line3 {
      width: 116px;
      height: 11px;
      background: none;
      position: relative;
      z-index: 0;
    }
  }

  .ztitem.active {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;

    p {
      position: relative;
      z-index: 1;
    }

    .line3 {
      width: 116px;
      height: 11px;
      background: rgba(87, 219, 255, 1);
      position: relative;
      z-index: 0;
    }
  }
}
</style>
